import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../../../../components/ui/card";
import { Badge } from "../../../../components/ui/badge";

const Activities: React.FC = () => {
	const activities = [
		{
			id: "mokumoku",
			title: "もくもく会",
			description: "各自が自分の学習テーマに取り組む会",
			schedule: "毎週土曜日 13:00-17:00",
			format: "ハイブリッド",
			tags: ["自主学習", "交流", "相談可"],
		},
		{
			id: "study",
			title: "勉強会",
			description: "特定のテーマについて学ぶ会",
			schedule: "月1回 19:00-21:00",
			format: "ハイブリッド",
			tags: ["講義形式", "質疑応答", "実践"],
		},
		{
			id: "workshop",
			title: "ワークショップ",
			description: "実践的なスキルを身につけるための体験型学習",
			schedule: "不定期開催",
			format: "対面優先",
			tags: ["ハンズオン", "グループワーク"],
		},
		{
			id: "exchange",
			title: "交流会",
			description: "メンバー同士の情報交換や親睦を深める会",
			schedule: "月1回 19:00-21:00",
			format: "対面優先",
			tags: ["ネットワーキング", "情報交換"],
		},
	];

	return (
		<section className="mb-16">
			<h2 className="text-3xl font-semibold mb-6">活動内容</h2>
			<div className="grid md:grid-cols-2 gap-6">
				{activities.map((activity) => (
					<Card key={activity.id}>
						<CardHeader>
							<CardTitle>{activity.title}</CardTitle>
							<CardDescription>{activity.description}</CardDescription>
						</CardHeader>
						<CardContent>
							<div className="space-y-4">
								<div>
									<p className="text-sm font-medium">開催スケジュール</p>
									<p className="text-sm text-gray-500">{activity.schedule}</p>
								</div>
								<div>
									<p className="text-sm font-medium">開催形式</p>
									<p className="text-sm text-gray-500">{activity.format}</p>
								</div>
								<div className="flex flex-wrap gap-2">
									{activity.tags.map((tag) => (
										<Badge key={tag} variant="secondary">
											{tag}
										</Badge>
									))}
								</div>
							</div>
						</CardContent>
					</Card>
				))}
			</div>
		</section>
	);
};

export default Activities;
